import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import withMediaQuery from "../../../hocs/withMediaQuery";
import { Link } from "@tanstack/react-router";
import { linkOptionsFromHref } from "../../../utils/searchParams";

const TrellisBreadcrumb = ({ items, mediaQuery }) => {
  const { t } = useTranslation(["common"]);
  return (
    <Row style={{ width: mediaQuery ? "100vw" : "calc(100vw - 90px)" }}>
      <Col
        xs={12}
        style={{
          borderBottom: "1px solid #dcdadd",
          backgroundColor: "#f5f3f6",
          paddingTop: "15px",
          paddingBottom: "15px",
          paddingLeft: "40px",
        }}
      >
        <ol
          role="navigation"
          aria-label={t(($) => $.common.breadcrumb["breadcrumbs"])}
          className="breadcrumb"
          style={{ marginBottom: "0px", fontSize: "14px" }}
        >
          {items.map((itm, i) => {
            return (
              <li key={i} className="breadcrumb-item ps-2 fw-normal">
                <Link className="text-decoration-none" {...linkOptionsFromHref(itm.href)} activeProps={{}}>
                  {itm.name}
                </Link>
              </li>
            );
          })}
        </ol>
      </Col>
    </Row>
  );
};

export default withMediaQuery("(max-width:992px)")(TrellisBreadcrumb);
